import Model from 'core/model/Model';

class PeeringdbMappingModel extends Model {
  get urlRoot() {
    return '/api/ui/peering/peeringdb/map';
  }
}

export default PeeringdbMappingModel;
